import { render, staticRenderFns } from "./CustomerInvoiceList.vue?vue&type=template&id=3b1278e6"
import script from "./CustomerInvoiceList.vue?vue&type=script&lang=js"
export * from "./CustomerInvoiceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports